import axios from 'axios';

const API = process.env.VUE_APP_API_URL;

let service = {
    authorize: (data) => {
        return axios.post(API + '/shopware/authorize', data);
    },
    hasCredentials: (id) => {
        return axios.post(API + '/shopware/has_credentials', {project_id: id});
    },
    clearCredentials: (id) => {
        return axios.post(API + '/shopware/clear_credentials', {project_id: id});
    }
};

export default service;